/// <reference path="../../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import * as AppMicWidgetStyle from './AppMicWidget.styles';
import { mergeStyles } from 'office-ui-fabric-react';
import { AppMicWidgetProps, AppMicWidgetRecorderState } from './AppMicWidget.props';
import { AddTooltipToElement } from '../../Tooltip/AddTooltipToElement';
import { MicrophoneListeningIllustration } from '../../../common/images/MicrophoneListeningIcon';
import { MicrophonePauseIllustration } from '../../../common/images/MicrophonePauseIcon';

export class AppMicWidget extends React.PureComponent<AppMicWidgetProps> {

  constructor(props: AppMicWidgetProps) {
    super(props);
  }

  public render() {
    const appMicWidget = this._getAppMicWidget();
    const { currentMicState } = this.props;

    return (
      <div style={AppMicWidgetStyle.getMicWidgetContainerCSSProperties()}>
        {appMicWidget}
        { currentMicState == AppMicWidgetRecorderState.Recording ? <div className={AppMicWidgetStyle.getPulseRingsStyle()}></div>: null}
      </div>
    );
  }

  private _getAppMicWidget() {
    // At present no pulsing animations is supported and hence return mic widget without pulsing.
    let appMicWidget = this._getMicWidgetWithoutPulsing();
    return appMicWidget;
  }

  private _getMicWidgetWithoutPulsing() {
    const { currentMicState } = this.props;

    const mergedStyle = this._getMergedStyleForMicWidget(currentMicState);
    const tooltipName = this._getTooltipNameForMicWidget(currentMicState);

    return (
      AddTooltipToElement(<button aria-labelledby="RecordingStatusLabel" aria-label={tooltipName} className={mergedStyle} onClick={this._onMicWidgetClicked}>
        { currentMicState == AppMicWidgetRecorderState.Recording ? <MicrophoneListeningIllustration/>: <MicrophonePauseIllustration/>}
        </button>, tooltipName)
    );
  }

  private _getMergedStyleForMicWidget(currentMicState: AppMicWidgetRecorderState) {
    let style = AppMicWidgetStyle.getMicWidgetStyle();

    style = mergeStyles(style, this._getPartialStyleForMicWidgetInCurrentState(currentMicState));

    return style;
  }

  private _getPartialStyleForMicWidgetInCurrentState(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return AppMicWidgetStyle.getRecordingMicWidgetStyle();

      case AppMicWidgetRecorderState.Paused:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();

      default:
        return AppMicWidgetStyle.getPausedMicWidgetStyle();
    }
  }

  private _getTooltipNameForMicWidget(currentMicState: AppMicWidgetRecorderState) {
    switch (currentMicState) {
      case AppMicWidgetRecorderState.Recording:
        return TranscriptionStrings.RecordingNonPausedLabel;

      case AppMicWidgetRecorderState.Paused:
        return TranscriptionStrings.RecordingPausedLabel;

      default:
        return "";
    }
  }

  private _onMicWidgetClicked = async (): Promise<void> => {
    const { onMicWidgetClicked } = this.props;

    if (onMicWidgetClicked) {
      onMicWidgetClicked();
    }
  };
}